






























































































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import store from "@/store";
import moment from "moment";
import { ILongTrendPeriod } from "@/types/longTrendPeriod";
import { getModule } from "vuex-module-decorators";
import LongTrendPeriodModule from "@/store/clients/LongTrendPeriod.module";
import { GraphPoint } from "@/types/graphPoint";

const LongTrendPeriod = getModule(LongTrendPeriodModule, store);

@Component
export default class BenchmarkCard extends Vue {
  @Prop({ default: true }) loading!: boolean;
  points = 0;
  periodMenu = false;
  isBenchmarkFormValid = true;
  submittingBenchmarkPeriod = false;

  benchmarkPeriodRules = {
    required: (value: number) => !!value || "Value required",
    valid: (value: number) => (value >= 30 && value <= 1000) || "Value must be between 30 and 1000",
  };

  tooltip =
    "The Baseline is the value, derived from the design or shop-test data, which shows the original expected performance of the vessel. It is used as the zero level when displaying actual performance. The Benchmark Period is the period, immediately after a trend event, during which data is collected to provide an initial performance level so that any subsequent changes in performance can be evaluated.";

  @Watch("loading", { immediate: true })
  onLoaded(val: boolean): void {
    if (!val) {
      if (this.benchmarkPeriod) {
        this.points = this.benchmarkPeriod;
      }
    }
  }

  updateBenchmarkPeriod(): void {
    this.$emit("customPeriod", this.points);
    this.periodMenu = false;
  }

  resetBenchmarkPeriod(): void {
    this.$emit("customPeriod", -1);
    this.periodMenu = false;
  }

  get longTrendPeriods(): ILongTrendPeriod | null {
    return LongTrendPeriod.longTrendPeriod;
  }
  get isBenchmarking(): boolean | undefined {
    return this.longTrendPeriods?.isBenchmarking;
  }
  get isManualBenchmark(): boolean | undefined {
    return this.longTrendPeriods?.isManualBenchmark;
  }
  get benchmarkPeriod(): number | undefined {
    return this.longTrendPeriods?.benchmarkPeriod;
  }
  get benchmarkPoint(): GraphPoint | undefined {
    return this.longTrendPeriods?.benchmarkPoint;
  }
  get pointCount(): number | undefined {
    return this.longTrendPeriods?.longTrendData.length;
  }
  get outlierPointsCount(): number | undefined {
    if (this.pointCount && this.longTrendPeriods) {
      return this.pointCount - this.longTrendPeriods.filteredLongTrendData.length;
    }
  }
  get requireBenchmarkPoints(): number | undefined {
    return this.isManualBenchmark ? 2 : this.longTrendPeriods?.benchmarkPeriod;
  }
  get remainingPointsCount(): number | undefined {
    if (this.requireBenchmarkPoints && this.longTrendPeriods) {
      return this.requireBenchmarkPoints - this.longTrendPeriods.filteredLongTrendData.length;
    }
  }
  get periodStart(): string {
    return this.longTrendPeriods?.start ? moment(this.longTrendPeriods.start).format("D MMM YYYY") : "N/A";
  }
  get periodEnd(): string {
    return this.benchmarkPoint?.x ? moment(this.benchmarkPoint.x).format("D MMM YYYY") : "N/A";
  }
  get yellowLine(): GraphPoint | undefined {
    return this.longTrendPeriods?.yellowLine;
  }
  get yellowOffset(): number | undefined {
    return this.longTrendPeriods?.yellowOffset;
  }
  get redLine(): GraphPoint | undefined {
    return this.longTrendPeriods?.redLine;
  }
  get redOffset(): number | undefined {
    return this.longTrendPeriods?.redOffset;
  }

  round(value: number, precision = 1): number {
    const multiplier = Math.pow(10, precision || 0);
    return Math.round(value * multiplier) / multiplier;
  }
}
